/* eslint-disable */
import {
  Card, Col,
  message,
  Row, Space,
  Spin,
  Typography
} from 'antd';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import { getProjectByIdService } from 'common/services/extends/project';
import { detectError, formatDateDDMMYYYY } from 'common/utils/functions';

const InfoCard = () => {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();

  const projectId = searchParams.get('projectId') || '';
  const staffFullTimeId = Number(searchParams.get('staffFullTimeId'));

  /* States */

  const queryKey = ['project-detail', projectId];

  const { isLoading, data: projectData } = useQuery(
    queryKey,
    () => getProjectByIdService(projectId),
    {
      enabled: !!projectId,
      onError: (error: unknown) => {
        if (error instanceof AxiosError) {
          const status = error.response?.status;
          message.error(t(detectError(status)));
        }
      }
    }
  );

  return (
    <Spin spinning={isLoading}>
      <Card
        title={(
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Typography.Title level={4}>
              {t('program.info')}
            </Typography.Title>
          </Space>
        )}
      >
        <div className="site-card-border-less-wrapper">
          <Row gutter={16}>
            <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('timesheet.codeProgram')}
              </Typography.Text>
              <Typography.Text strong>
                {projectData?.projectData?.code || ''}
              </Typography.Text>
            </Col>
            <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('program.nameCustomer')}
                {' '}
              </Typography.Text>
              <Typography.Text strong>
                {projectData?.projectData?.customerName || ''}
              </Typography.Text>
            </Col>
            <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('timesheet.nameProgram')}
                {' '}
              </Typography.Text>
              <Typography.Text strong>
                {projectData?.projectData?.name || ''}
              </Typography.Text>
            </Col>
            <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('program.fromDate')}
              </Typography.Text>
              <Typography.Text strong>
                {formatDateDDMMYYYY(projectData?.projectData?.fromDate, '/')}
              </Typography.Text>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('program.toDate')}
              </Typography.Text>
              <Typography.Text strong>
                {formatDateDDMMYYYY(projectData?.projectData?.toDate, '/')}
              </Typography.Text>
            </Col>
            <Col xs={12} sm={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('program.personInChargeAC')}
                {' '}
              </Typography.Text>
              <Typography.Text strong>
                {projectData?.accountant?.fullname || ''}
              </Typography.Text>
            </Col>
            <Col xs={12} sm={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                {t('program.personInChargeOP')}
                {' '}
              </Typography.Text>
              <Typography.Text strong>
                {projectData?.operation?.fullname || ''}
              </Typography.Text>
            </Col>
            {staffFullTimeId ? (
              <Col xs={12} sm={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text>
                  {t('timesheet.payrollManage')}
                  {' '}
                </Typography.Text>
                <Typography.Text strong>
                  {projectData?.payrolls?.find((item) => item.id === staffFullTimeId)?.fullname || ''}
                </Typography.Text>
              </Col>
            ) : null}
          </Row>
        </div>
      </Card>
    </Spin>
  );
};

export default InfoCard;
